<template>
  <div>
    <v-alert type="error" v-for="error in errors" :key="error">{{
      error
    }}</v-alert>
    <AdvancedListView
      :type="field.entity_type"
      :scope="scope"
      :persistence="field.persistence"
      :options="{ title: field.label, disablePagination: true }"
      forms="popup"
      ref="listView"
    ></AdvancedListView>
  </div>
</template>

<script>
import AdvancedListView from "../AdvancedListView";

export default {
  name: "ListField",
  components: { AdvancedListView },
  props: ["entity", "field", "value"],
  computed: {
    errors() {
      return this.$parent.errors[this.field.name];
    },
    scope() {
      // TODO: при создании новой дочерней записи - еще нет id и соответственно нет scope
      //  нужно корректно обработать
      let scope = {};
      for (let [key, field_name] of Object.entries(this.field.scope)) {
        console.log("SS", this.entity, field_name);
        scope[key] = this.entity[field_name];
      }
      console.log("SSCOPE", scope);
      return scope;
    }
  },
  mounted() {
    this.$refs.listView.$on("entitiesChanged", this.onEntitiesChanged);
  },
  beforeDestroy() {
    this.$refs.listView.$off("entitiesChanged", this.onEntitiesChanged);
  },
  methods: {
    onEntitiesChanged(entities) {
      console.log("onEntitiesChanged", entities);
      let data = [];
      for (const e of entities) {
        data.push(e.data);
      }
      this.entity[this.field.name] = data;
    }
  },
  watch: {
    errors: {
      handler() {
        if (this.errors)
          for (const error of this.errors)
            this.$root.$emit("notify", error, "red");
      },
      deep: true
    }
  }
};
</script>

<style scoped></style>
